import {START_DATE, END_DATE} from '../actions';

export default (state = {startDate: '', endDate: ''}, action) => {
	switch (action.type) {
		case START_DATE:
			return {startDate: action.payload, endDate: state.endDate};
		case END_DATE:
			return {startDate: state.startDate, endDate: action.payload};
	}
	return state;
}